import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import { TypographyTextProps } from "@portal/BaseComponents/Typography/type";
import { useFormats } from "@portal/hooks/use-formats";
import { amountFormats } from "@sinecycle/growcomponents";

interface AmountTextProps {
  amount: number;
  extra?: JSX.Element;
  textProps?: TypographyTextProps;
  format?: "SHORT" | "FULL";
  prefix?: string;
  currency: string;
}

function AmountText(props: AmountTextProps) {
  const {
    amount,
    extra,
    textProps,
    format = "SHORT",
    prefix,
    currency,
  } = props;

  const { locale } = useFormats();
  const value =
    format === "SHORT"
      ? amountFormats.amountShort(amount, currency, locale)
      : amountFormats.currency(amount, { currency, locale });
  const Amount = (
    <TypographyText {...textProps}>{`${prefix ?? ""} ${value}`}</TypographyText>
  );
  return (
    <Flex vertical justify="center" style={{ height: "100%" }} align="end">
      {Amount}
      {extra}
    </Flex>
  );
}

export { AmountText };
